@import "../../variables.scss";

.onboardImage {
  &__imageText {
    position: relative;
    z-index: 5;
    color: $color-white;

    h3 {
      font-size: 1rem;
      font-weight: 700;
    }

    h2 {
      font-size: 1.75rem;
      font-weight: 400;
    }

    p {
      font-size: 1rem;
      font-weight: 400;
    }
  }

  &__image {
    position: absolute;
    z-index: 5;
  }

  &__well_done {
    text-align: center;
  }

  &__progressBar {
    height: 7px;
    background-color: $color-white;
  }

  &__progressBarFill {
    height: 100%;
    background-color: $color-mid-blue;
  }

  &__openProgressMapBtn {
    background: transparent;
    border: none;
    margin-bottom: 1rem;
    color: $color-white;
    font-size: 12px;
  }
}
